import SurveySubmissionQuestion from './SurveySubmissionQuestion';

export default SurveySubmissionQuestion;
